import React from 'react';

const SpaceTaskCreatingIndicator = () => {
    return (
        <div className="flex items-center gap-2 text-sm text-gray-600">
            <span className="bg-gradient-to-r from-[#56B648] to-[#FFB902] bg-clip-text text-transparent font-medium">
                Creating task...
            </span>
            <div className="flex gap-1">
                <div className="w-1 h-1 bg-gray-400 rounded-full animate-pulse"></div>
                <div className="w-1 h-1 bg-gray-400 rounded-full animate-pulse" style={{ animationDelay: '0.2s' }}></div>
                <div className="w-1 h-1 bg-gray-400 rounded-full animate-pulse" style={{ animationDelay: '0.4s' }}></div>
            </div>
        </div>
    );
};

export default SpaceTaskCreatingIndicator;
